<script setup lang="ts">
import PrimaryButton from '@/components/common/PrimaryButton.vue';
import ModalDialogV2 from '@/components/common/ModalDialogV2.vue';
import GhostButton from '@/components/common/GhostButton.vue';

const { t } = useTranslations();
const open = defineModel<boolean>({
  required: true,
});
</script>

<template>
  <ModalDialogV2 centered v-model="open" static size="lg">
    <template #default>
      <img
        class="mx-auto -mt-12 mb-5 w-full max-w-56"
        src="/images/cleepo/cleepo_contento.png"
        alt=""
      />
      <h3 class="mb-3 text-2xl font-medium">
        {{ t('cart_checkout.cleepo.checkout_completed_modal.title') }}
      </h3>
      <p>
        {{ t('cart_checkout.cleepo.checkout_completed_modal.description') }}
      </p>
      <p class="mt-2 text-sm italic">
        {{ t('cart_checkout.cleepo.checkout_completed_modal.description_2') }}
      </p>
    </template>
    <template #footer>
      <div class="flex w-full flex-col gap-2">
        <router-link :to="{ name: 'CleepoDomainView' }">
          <PrimaryButton class="mx-auto w-full max-w-sm" type="button">
            {{ t('cart_checkout.cleepo.checkout_completed_modal.button') }}
            <template #trailing>
              <IconifyIcon class="size-4" icon="heroicons:arrow-long-right" />
            </template>
          </PrimaryButton>
        </router-link>
        <router-link :to="{ name: 'CleepoDashboardView' }">
          <GhostButton class="mx-auto w-full max-w-sm" type="button">
            {{ t('cart_checkout.cleepo.checkout_completed_modal.cancel') }}
          </GhostButton>
        </router-link>
      </div>
    </template>
  </ModalDialogV2>
</template>
